  <template>
  <div>
    <h1 class="title">My Orders</h1>

    <b-container>
      <ul class="tabs-navbar">
        <li
          class="d-inline tabs-item"
          :class="{ 'text-white': filter == 'active' }"
        ><a @click="filterOrders({ active_for_customer: true })">Active</a></li>

        <li
          class="d-inline tabs-item ml-3"
          :class="{ 'text-white': filter == 'recent' }"
        ><a @click="filterOrders({ recent_for_customer: true })">Recent</a></li>
      </ul>

      <div
        v-if="is_loading"
        class="loader"
      >
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>

      <p v-else-if="orders.length === 0" class="text-center">You have no orders yet!</p>

      <b-row v-else class="border-bottom">
        <b-col cols="3">
          <h5>Order Number</h5>
        </b-col>

        <b-col cols="3">
          <h5>Address</h5>
        </b-col>

        <b-col cols="3">
          <h5>Placed On</h5>
        </b-col>

        <b-col cols="3">
          <h5>Total</h5>
        </b-col>
      </b-row>

      <b-row
        v-for="order in orders"
        :key="order.id"
        class="pt-3 border-bottom font-lighter order-row"
        @click="show_order(order.id)"
      >
        <b-col cols="3">
          <p>Order # {{ order.id }}</p>
        </b-col>

        <b-col cols="3" class="mt-1">
          <p>{{ order.attributes.delivery_address }}</p>
        </b-col>

        <b-col cols="3">
          <p>{{ order.attributes.placed_on | moment("DD-MMM-YYYY, h:mm:ss a") }}</p>
        </b-col>

        <b-col cols="3">
          <p>{{ order.attributes.total }}</p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { getOrders } from '../store/api'

export default {
  name: 'orders',

  data() {
    return {
      orders: [],
      filter: 'active',
      is_loading: true,
    }
  },

  created() {
    getOrders({ search: { active_for_customer: true } })
      .then(response => {
        this.orders = response.data
        this.is_loading = false
      })
  },

  methods: {
    filterOrders(filter_by) {
      this.set_default()
      this.filter == 'active' ? this.filter = 'recent' : this.filter = 'active'
      getOrders({ search: filter_by })
        .then(response => {
          this.orders = response.data
          this.is_loading = false
        })
    },
    show_order(order_id) {
      this.$router.push(`orders/${order_id}`)
    },
    set_default() {
      this.is_loading = true
      this.orders = []
    },
  },

  beforeCreate: function() {
    document.body.className = '';
  },
}
</script>

<style scoped>
  h1 {
    text-align: center;
  }
  .font-lighter {
    font-weight: lighter;
  }
  .tabs-navbar {
    height: 3rem;
    background-color: #7F86FF;
    border-bottom-right-radius: 4rem;
    border-top-left-radius: 4rem;
    padding-top: 12px;
  }
  .tabs-item {
    height: 100%;
    border: 0;
    background-color: Transparent;
    color: rgba(255, 255, 255, 0.5);
  }
  .tabs-item:hover {
    cursor: pointer;
    color: white;
  }
  .order-row {
    cursor: pointer;
  }
  .order-row:hover {
    background-color: #e9ecef;
  }
</style>
